import { combineEpics } from "redux-observable";
import { of } from "rxjs";
import { catchError, map, mergeMap } from "rxjs/operators";

import { actionCreators } from "../actions";
import { windowEvent$ } from "../utils/any/rxjs";
import { Epic } from "../utils/types";

import { isFocused } from "./helpers/active";

// epics

const onIdleChange: Epic = (action$, state$, { App }) =>
    isFocused.pipe(
        map(isFocused => (isFocused ? actionCreators.onActive() : actionCreators.onIdle())),
        catchError(err => {
            console.error("Error", err);
            return of<never>();
        })
    );

const onOnlineChange: Epic = (action$, state$, { App }) =>
    windowEvent$("online").pipe(
        mergeMap(() => {
            App.proto.resetReconnectTimer();
            return of<never>();
        }),
        catchError(err => {
            console.error("Error", err);
            return of<never>();
        })
    );

export const idleEpic = combineEpics(onIdleChange, onOnlineChange);
